import { create } from "zustand";

export const usePodadoresStore = create((set) => ({
  podadores: [],
  podadoresSelect: [],
  podador: null,

  setPodadores: (podadores) => {
    set({ podadores: podadores });
  },

  setPodador: (podador) => {
    set({ podador: podador });
  },
  setPodadoresSelect: (podadores) => {
    set({ podadoresSelect: podadores });
  },
}));
